import {Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {NavigationService} from "../../../services/navigations/navigation.service";
import {Router} from "@angular/router";
import {NotificationsService} from "../../../services/notifications/notifications.service";
import {isPlatformBrowser} from "@angular/common";
import {AuthService} from "../../../services/auth/auth.service";
import {GlobalService} from "../../../services/global/global.service";

@Component({
    selector: 'app-impact-header',
    templateUrl: './impact-header.component.html',
    styleUrls: ['./impact-header.component.scss'],
    standalone: false
})
export class ImpactHeaderComponent implements OnInit {
  @Output('backDetect') backDetect: EventEmitter<any> = new EventEmitter<any>();

  public notificationCount: number = 0;
  public active = 'home';
  public isBrowser: boolean = true;

  constructor(
    private notificationService: NotificationsService,
    private navigationService: NavigationService,
    private globalService: GlobalService,
    public router: Router,
    public auth: AuthService,
  ) {
    this.active = 'impact-map';
    this.isBrowser = this.globalService.isBrowser;
  }

  ngOnInit() {
    this.notificationService.notificationEvent.subscribe(val => {
      this.notificationCount = val;
    });
  }

  openSearchModal(): void {
    this.navigationService.openSearchModal();
  }

  openPostModal(): void {
    this.navigationService.openPostModal('global', 0);
  }

  openNotifications(): void {
    this.navigationService.openNotifications();
  }

  openHome(): void {
    this.navigationService.openHome();
  }

  openImpactSuite(): void {
    this.navigationService.openImpactSuite();
  }

  back(): void {
    this.backDetect.emit(true);
    this.navigationService.back(this.router.url);
  }

  navigateTo(tab: string, path: string) {
    this.active = tab;
    this.router.navigate([path]);
  }

}
